export { PlanDetailSocial } from "./Social";
export { PlanDetailCharacteristics } from "./Characteristics";
